import React, { Component } from "react";
import { connect } from "react-redux";
import * as postActions from "../../store/action/post";
import _ from "lodash";
import Link from "src/components/link";
import Status from "src/components/util/status";
import Date from "src/components/util/date";
import localStore from "src/utils/local-storage";
import ImageLoader from "../image-loader/ImageLoader";
import UserAvatar from "react-user-avatar";
import CreatorItem from "../posts/tab/creator-item/creator-item";
import CreatableSelect from "react-select";
import Select from "react-select";
import PostService from "../../services/PostService";
import moment from "moment";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import RoyaltiesPhotographerService from "../../services/RoyaltiesPhotographerService";
import RoyaltiesEditorService from "../../services/RoyaltiesEditorService";
import slug from '@sindresorhus/slugify';
import { udpateLogPost } from "../../utils/common"
import ApiService from "src/services/ApiService";
import GAService from "../../services/GAService";
import AiService from "../../services/AiService";

import { ToastContainer, toast } from 'react-toastify';
const CONTENT_URL = process.env.REACT_APP_CONTENT;
const SI_SYMBOL = ["", "k", "tr", "tỉ", "T", "P", "E"];

class RoyaltiesReportItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showEdit: false,
      onHover: false,
      contentcreatortype: [],
      editorRoyalties: props.postItem.royalties_editor_value,
      photoRoyalties: props.postItem.royalties_photo_value,
      editorRoyaltiesName: props.postItem.royalties_editor,
      photoRoyaltiesName: props.postItem.royalties_photographer,
      listRoyaltiesEditor: props.listRoyaltiesEditor,
      listRoyaltiesPhoto: props.listRoyaltiesPhoto,
      pageviews: props.postItem.pageviews,
      pageviews_value: props.postItem.pageviews_value,
      timeOnPage: props.postItem.timeOnPage,
      showModal: false,
      isLoadingE: false,
      isLoadingP: false,
      filters: {
        page: {
          fieldName: "_start",
          value: "1"
        },
        limit: {
          fieldName: "_limit",
          value: "50"
        },
        search: {
          fieldName: "_q",
          value: ""
        },
      },
      postItem: props.postItem,
      postRevision: null,
      isUpdatingPageview: false
    };
  }

  generateCategory = (idx, category, clickChangeCategory) => {
    category = _.unionBy(category, "_id");
    let stringBuilder = [];
    category.forEach((cat, index) => {
      if (index === 0) {
        let stringBuilder1 = (
          <button
            key={`item-category${cat._id}${idx}${index}`}
            className="mr-1 btn btn-link text-left"
            onClick={() => clickChangeCategory(cat.url)}
          >
            {cat.name}
          </button>
        );
        stringBuilder.push(stringBuilder1);
      }
    });
    return stringBuilder;
  };

  formatNumber(number) {
    var tier = (Math.log10(number) / 3) | 0;
    if (tier == 0) return number;
    var suffix = SI_SYMBOL[tier];
    var scale = Math.pow(10, tier * 3);
    var scaled = number / scale;

    return parseFloat(scaled.toFixed(1)) + suffix;
  }

  formatThousandNumber(num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
  }

  closeModal = () => {
    this.setState({ showModal: false });
  };

  openModal = () => {
    this.setState({ showModal: true });
  };

  updateView(url, postItem){
    this.setState({isUpdatingPageview: true})
    if(!url) {
      toast.error(`Không tìm thấy Bài Viết`);
      return;
    }
    let increment_id;
    const groupId = /-(\d+)\.html/.exec(url);

    if (groupId && groupId[1]) {
      increment_id = groupId[1];
    }

    if(!increment_id) {
      toast.error(`Không tìm thấy Bài Viết`);
      return;
    }
    
    GAService.getViewByID(increment_id).then(
      result => {
        if(result.status){
          toast.success(`Đã Update Pageview cho bài viết: ${postItem.title}`)
          this.setState({
            pageviews: result.pageviews,
            pageviews_value: result.pageviews_value,
            timeOnPage: result.timeOnPage,
          })
        }
        else{
          toast.error(`Không Update Pageview cho bài viết`);
        }
        this.setState({isUpdatingPageview: false})
      }
    );


  };

  updateScore(postItem){
    if(!postItem) return;
    console.log(postItem);
    
    // trigger ai_score
    AiService.getAiScoreByID(postItem.increment_id);
  }

  handleInputChangeEditor = (inputValue) => {

    if (inputValue && inputValue.length >= 2) {
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        const slugValue = slug(inputValue);
        this.setState({ isLoadingE: true })
        RoyaltiesEditorService.slugfilter(slugValue)
          .then(result => {
            result = _.forEach(result, (itm) => {
              let newItem = {
                increment_id: itm.increment_id,
                _id: itm._id,
                label: itm.label,
                slug: itm.slug,
                createdAt: itm.createdAt,
                updatedAt: itm.updatedAt,
                id: itm.id,
              }
              itm.value = newItem;
            })

            this.setState({ listRoyaltiesEditor: result, isLoadingE: false })
          })
          .catch(err => {
            callback([]);
          });
      }, 200);
    }

  };

  handleInputChangePhoto = (inputValue) => {
    if (inputValue && inputValue.length >= 2) {
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        const slugValue = slug(inputValue);
        this.setState({ isLoadingP: true })
        RoyaltiesPhotographerService.slugfilter(slugValue)
          .then(result => {
            result = _.forEach(result, (itm) => {
              let newItem = {
                increment_id: itm.increment_id,
                _id: itm._id,
                label: itm.label,
                slug: itm.slug,
                createdAt: itm.createdAt,
                updatedAt: itm.updatedAt,
                id: itm.id,
              }
              itm.value = newItem;
            })

            this.setState({ listRoyaltiesPhoto: result, isLoadingP: false })
          })
          .catch(err => {
            callback([]);
          });
      }, 200);
    }

  };

  componentDidUpdate(prevProps) {
    if (prevProps.postItem !== this.props.postItem) {
      // console.log('update');
    }
  }

  render() {
    const { isLoadingE, isLoadingP, editorRoyaltiesName, listRoyaltiesEditor, listRoyaltiesPhoto } = this.state;
    let _user = localStore.get("_user");
    const { idx, isMobile } = this.props;
    const { postItem } = this.state;
    const money_editor = postItem.royalties_editor_value
      ? parseInt(postItem.royalties_editor_value.value)
      : 0;
    const money_photo = postItem.royalties_photo_value
      ? parseInt(postItem.royalties_photo_value.value)
      : 0;

    // const time = moment(postItem.updatedAt).format("DD/MM hh:mm");

    if (isMobile) {
      return (
        <>
          <tr key={`post-${idx}`} className="royalties-report-item">
            <td onClick={this.openModal}>
              <div className="d-flex p-2">
                <div className="avatar">
                  {(postItem.img_ver && (
                    <ImageLoader
                      className="lazyload img-circle"
                      src={postItem.img_ver}
                      width="100"
                    />
                  )) || (
                      <img src={process.env.PUBLIC_URL + "assets/images/100x160.png"} />
                    )}
                </div>
                <div className="right">
                  <h6 className={`title ${postItem.posttype.type_code == "draft" ? "text-red" : ""}`}>
                    {postItem.title || "Chưa đặt tên"}
                    {!this.state.showEdit && postItem.editing && (
                      <i className="ml-2 fas fa-lock"></i>
                    )}
                  </h6>
                  <div className="d-flex justify-content-between align-items-center">
                    <span
                      className=""
                      style={{ fontSize: "0.8em", color: "#1179d7" }}
                    >
                      {(postItem.contentpenname &&
                        postItem.contentpenname.map(item => item.label).join(", ")) ||
                        "-"}
                    </span>
                    <span className="time text-dark">
                      {/* {postItem.posttype && time} */}
                      <Date published_at={postItem.publishedAt} typecode={postItem.posttype.type_code} hideUpdatedTime={true} hideText={true} />
                    </span>
                  </div>

                  <div className="py-1 d-flex justify-content-between align-items-center">
                    <span className="cate-name">
                      {this.generateCategory(idx, postItem.categories, this.props.clickChangeCategory)}
                    </span>

                    <span
                      className="btn bg-gradient-primary btn-xs"
                      style={{
                        fontSize: "0.8em",
                        padding: "0.25em 0.4em",
                        lineHeight: "1"
                      }}
                    >
                      Tổng nhuận: <span> </span>
                      {this.formatNumber(
                        (this.state.editorRoyalties
                          ? parseInt(this.state.editorRoyalties.value * 1000)
                          : 0) +
                        (this.state.photoRoyalties
                          ? parseInt(this.state.photoRoyalties.value * 1000)
                          : 0)
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </td>
          </tr>

          <Modal
            show={this.state.showModal}
            onHide={this.closeModal}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Body>
              <div className="row">
                <div className="col-8">
                  <strong>Biên tập</strong>
                </div>
                <div className="col-4">
                  <strong>Nhuận bút</strong>
                </div>
              </div>
              {/*
              <div className="row mt-2">
                <div className="col-8">
                  <Select
                    value={this.state.editorRoyaltiesName}
                    options={listRoyaltiesEditor}
                    onChange={value => this.updateRoyaltiesEditor(value)}
                    menuPosition="fixed"
                    onInputChange={this.handleInputChangeEditor}
                    isLoading={isLoadingE}
                  />
                </div>
                <div className="col-4">
                  {!_user.can_set_royalties ? (
                    money_editor.toLocaleString("it-IT", {
                      style: "currency",
                      currency: "VND"
                    })
                  ) : (
                      <Select
                        value={this.state.editorRoyalties}
                        options={this.props.royalties_list}
                        onChange={value => this.onEditorRoyaltiesSelected(value)}
                        isSearchable={true}
                        placeholder=""
                        menuPosition="fixed"
                      />
                    )}
                </div>
              </div>
              */}
              <div className="row mt-2">
                <div className="col-8">
                  <strong>Bút danh</strong>
                </div>
                <div className="col-4">
                  <strong>Điểm</strong>
                </div>
              </div>

              <div className="row mt-2">
                <div className="col-8">
                  <Select
                    value={this.state.photoRoyaltiesName}
                    options={listRoyaltiesPhoto}
                    onChange={value => this.updateRoyaltiesPhotographer(value)}
                    menuPosition="fixed"
                    onInputChange={this.handleInputChangePhoto}
                    isLoading={isLoadingP}
                    isClearable={true}
                  />
                </div>
                <div className="col-4">
                  {!_user.can_set_royalties ? (
                    money_photo.toLocaleString("it-IT", {
                      style: "currency",
                      currency: "VND"
                    })
                  ) : (
                      <Select
                        value={this.state.photoRoyalties}
                        options={this.props.royalties_list}
                        onChange={value =>
                          this.onPhotographerRoyaltiesSelected(value)
                        }
                        isSearchable={true}
                        placeholder=""
                        menuPosition="fixed"
                      />
                    )}
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={this.closeModal}>Đóng</Button>
            </Modal.Footer>
          </Modal>
        </>
      );
    }

    return (
      <tr key={`post-${idx}`} className="" style={{ height: "63px" }}>
        <td className="title title-edit">
          <div className={`${postItem.posttype.type_code == "draft" ? "text-red" : ""}`} >
            <a href={`https://www.saostar.vn${postItem.post_url}`} target="_blank" rel="noopener noreferrer" >
              {postItem.title || "Chưa đặt tên"}{" "}
            </a>
            {postItem.editing && <i className="fas fa-lock"></i>}
            {(postItem.editor_type &&
              // && (postItem.editor_type === 'normal' && <button type="button" className="btn btn-sm btn-outline-primary ml-2">Bài thường</button>)
              postItem.editor_type === "mini" && (
                <button
                  type="button"
                  className="btn btn-sm btn-outline-danger ml-2"
                >
                  Bài Mini
                </button>
              )) ||
              (postItem.editor_type === "special" && (
                <button
                  type="button"
                  className="btn btn-sm btn-outline-warning ml-2"
                >
                  Bài Special
                </button>
              )) ||
              (postItem.editor_type === "video" && (
                <button
                  type="button"
                  className="btn btn-sm btn-outline-dark ml-2"
                >
                  Bài Video
                </button>
              ))}
            {postItem.is_pr && (
              <button type="button" className="btn btn-sm btn-outline-info ml-2">
                PR
              </button>
            )}
            <a href={`/posts/edit/${postItem._id}`} target="_blank" rel="noopener noreferrer" className="ml-2 btn-edit">
              <span className="btn btn-outline-primary btn-sm mr-2"><i className="fas fa-pencil-alt"></i></span>
            </a>
            <div
              className={
                "tools tools-posts" + (this.state.onHover ? " active" : "")
              }
            >
              {this.state.showEdit && (
                <>
                  {postItem.editing && (
                    <Link
                      to={`/posts/edit/${postItem._id}`}
                      className="btn btn-warning btn-sm ml-2"
                    >
                      <i className="fas fa-lock"></i>{" "}
                      {postItem.editing.fullname || postItem.editing.email}
                    </Link>
                  )}
                </>
              )}  
            </div>
            
          </div>
        </td>

        <td style={{ width: "120px" }}>
          {postItem.posttype && (
            <Date published_at={postItem.publishedAt} typecode={postItem.posttype.type_code} hideUpdatedTime={true} hideText={true} />
          )}
        </td>

        <td style={{ width: "150px" }}>
          <span className="tag tag-success">
            {this.generateCategory(idx, postItem.categories, this.props.clickChangeCategory)}
          </span>
        </td>
        {/*
        <td style={{ width: "240px" }}>
          <CreatableSelect
            value={this.state.editorRoyaltiesName}
            options={listRoyaltiesEditor}
            onChange={value => this.updateRoyaltiesEditor(value)}
            menuPosition="fixed"
            onInputChange={this.handleInputChangeEditor}
            isLoading={isLoadingE}
          />
        </td>
        */}

        <td style={{ width: "150px" }}>
          {postItem.contentpenname && postItem.contentpenname.length > 0 &&
            <button
              className="mr-1 btn btn-link text-left"
              onClick={() => this.props.clickChangeContentpenname(postItem.contentpenname[0].slug)}
            >
              {postItem.contentpenname[0].label}
            </button>
          }
        </td>
        {/*
        <td
          style={{ width: "110px" }}
          className="royalties-editor-value text-right"
        >
          {!_user.can_set_royalties ? (
            money_editor.toLocaleString("it-IT", {
              style: "currency",
              currency: "VND"
            })
          ) : (
              <Select
                value={this.state.editorRoyalties}
                options={this.props.royalties_list}
                onChange={value => this.onEditorRoyaltiesSelected(value)}
                isSearchable={true}
                placeholder=""
                menuPosition="fixed"
                isDisabled={this.state.editorRoyaltiesName ? false : true}
              />
            )}
        </td>
        */}
        <td
          style={{ width: "60px" }}
          className="text-right"
        >
          {postItem.ai_score ? postItem.ai_score : (
            _user.role.type === "superadmin" &&
            <button className="btn btn-outline-success btn-sm" onClick={(e) => this.updateScore(postItem)}>
              <i className={`fas fa-sync ${this.state.isUpdatingPageview ? "fa-spin" : ""}`}></i>
            </button>
          )
          }
        </td>

        <td
          style={{ width: "60px" }}
          className="text-right"
        >
          <div>{postItem.video_url ? "Có" : "Không"}</div>
        </td>
        {/*
        <td style={{ width: "60px" }} className="text-right">
          {this.formatNumber(
            (this.state.editorRoyalties
              ? parseInt(this.state.editorRoyalties.value * 1000)
              : 0) +
            (this.state.photoRoyalties
              ? parseInt(this.state.photoRoyalties.value * 1000)
              : 0)
          )}
        </td>
        */}

        <td style={{ width: "60px" }} className="text-right">
          <div>{this.state.timeOnPage ? this.state.timeOnPage : null}</div>
        </td>

        <td style={{ width: "120px" }} className="view-count text-right">
          {this.state.pageviews ? this.formatThousandNumber(this.state.pageviews) : 
            <button disabled={this.state.isUpdatingPageview} className="btn btn-outline-success btn-sm" onClick={(e) => this.updateView(postItem.post_url, postItem)}>
              <i className={`fas fa-sync ${this.state.isUpdatingPageview ? "fa-spin" : ""}`}></i>
            </button>
          }
        </td>

        <td style={{ width: "120px" }} className="view-count text-right">
          {(this.state.pageviews_value && this.state.pageviews && this.state.pageviews_value < this.state.pageviews) ? this.formatThousandNumber(this.state.pageviews_value) : 
            <button disabled={this.state.isUpdatingPageview} className="btn btn-outline-success btn-sm" onClick={(e) => this.updateView(postItem.post_url, postItem)}>
              <i className={`fas fa-sync ${this.state.isUpdatingPageview ? "fa-spin" : ""}`}></i>
            </button>
          }
        </td>
        
      </tr>
    );
  }

  updateRoyaltiesEditor(value) {
    this.setState({ editorRoyaltiesName: value }, () => {
      delete value.value;
      PostService.update({
        royalties_editor: value,
        id: this.props.postItem._id
      }).then(result => {
        if (result) {
          toast.success("Câp nhật biên tập viên thành công");
          this.handleRoyaltyRevision("Set biên tập viên", value);
        }
      });
    });
  }

  updateRoyaltiesPhotographer(value) {
    this.setState({ photoRoyaltiesName: value }, () => {
      if (value) {
        delete value.value
      } else {
        this.onPhotographerRoyaltiesSelected(null)
      }

      PostService.update({
        royalties_photographer: value,
        id: this.props.postItem._id
      }).then(result => {
        if (result) {
          toast.success("Câp nhật phóng viên ảnh thành công");
          this.handleRoyaltyRevision("Set photographer", value);
        }
      });


    });
  }

  onEditorRoyaltiesSelected(value) {
    const updateValue = parseInt(
      (value ? value.value : 0) -
      (this.state.editorRoyalties ? this.state.editorRoyalties.value : 0)
    );
    this.props.updateTotal(updateValue, "editor");
    
    let log_action = '';
    if(!this.state.editorRoyalties) {
      log_action = udpateLogPost(`set nhuận bút: ${value.label || ''}`);
    } else {
      log_action = udpateLogPost(`thay đổi nhuận bút: ${this.state.editorRoyalties.label || ''} => ${value.label || ''}`);
    }

    this.setState({ editorRoyalties: value });

    PostService.update({
      royalties_editor_value: value,
      id: this.props.postItem._id,
      log_action: `${this.props.postItem.log_action}${log_action}`
    }).then(result => {
      if (result) {
        this.handleRoyaltyRevision("Set nhuận biên tập viên", value);
        // toast.success("Câp nhật nhuận bút thành công");
      }
    });
  }

  onPhotographerRoyaltiesSelected(value) {
    const updateValue = parseInt(
      (value ? value.value : 0) -
      (this.state.photoRoyalties ? this.state.photoRoyalties.value : 0)
    );
    this.props.updateTotal(updateValue, "photo");

    let log_action = '';
    if(!this.state.photoRoyalties) {
      log_action = udpateLogPost(`set nhuận ảnh: ${value.label || ''}`);
    } else {
      log_action = udpateLogPost(`thay đổi nhuận ảnh: ${this.state.photoRoyalties.label || ''} => ${value.label || ''}`);
    }

    this.setState({ photoRoyalties: value });
    PostService.update({
      royalties_photo_value: value,
      id: this.props.postItem._id,
      log_action: `${this.props.postItem.log_action}${log_action}`
    }).then(result => {
      if (result) {
        // toast.success("Câp nhật nhuận ảnh thành công");
        this.handleRoyaltyRevision("Set nhuận photographer", value);
      }
    });
  }

  handleRoyaltyRevision = (preText, valueObj) => {    
    const currentPost = this.props.postItem;

    if (this.state.postRevision) {
      this._addRoyaltyRevision({
        postRevision: this.state.postRevision, 
        currentPost,
        preText,
        valueObj
      });
    } else {
      ApiService.get(`/post-revisions?post=${currentPost._id}`).then(data => {
        if (data && data[0]) {
          this.setState({
            postRevision: data[0]
          }, () => {
            this._addRoyaltyRevision({
              postRevision: this.state.postRevision, 
              currentPost,
              preText,
              valueObj
            });
          });
        } else {
          ApiService.post(`/post-revisions`, {post: currentPost._id}).then(data2 => {
            this.setState({
              postRevision: data2
            }, () => {
              this._addRoyaltyRevision({
                postRevision: this.state.postRevision, 
                currentPost,
                preText,
                valueObj
              });
            });
          });
        }
      });
    }    
  }

  _addRoyaltyRevision({postRevision, currentPost, preText, valueObj}) {
    const user = localStore.get("_user");
    if (postRevision && currentPost._id) {
      const royaltyLog = `${user.username} - ${preText} - ${valueObj ? valueObj.label : null} - ${moment().format('DD/MM/YYYY HH:mm')}<br/>`;
      ApiService.put(`/post-revisions/${postRevision._id}`, {
        royalty: `${postRevision.royalty || ""}${royaltyLog}`
      }).then(data => {
        this.setState({
          postRevision: data
        });
      })
    }
  }
}
export default connect(
  store => {
    return {
      login: store.loginInfo,
      config: store.config,
      royalties_list: store.config.royalties_list || []
    };
  },
  dispatch => {
    return {
      setCurrentPost: value => {
        dispatch(postActions.setCurrentPost(value));
      },
      deletePost: value => {
        dispatch(postActions.deletePost(value));
      }
    };
  }
)(RoyaltiesReportItem);
